<template>
  <div itemscope itemtype="http://schema.org/BlogPosting">
    <preloader v-if="loading" />
    <div v-else>
      <article
        :id="`post-${slug}`"
        class="seasidetms_open_post post-85 post type-post status-publish format-image has-post-thumbnail hentry category-gadgets post_format-post-format-image"
      >
        <header class="seasidetms_post_header entry-header">
          <h1 class="seasidetms_post_title entry-title" itemprop="name">
            {{ postTitle }}
          </h1>
        </header>
        <div class="seasidetms_post_cont_info entry-meta">
          <span class="seasidetms_post_date">
            <abbr class="published" :title="postDate" itemprop="datePublished">
              {{ postDate }}
            </abbr>
          </span>
        </div>
        <figure class="seasidetms_img_wrap">
          <a
            href="#"
            title="Best smartphones for selfies"
            rel="ilightbox[img_85_5eedb66667f22]"
            class="seasidetms_img_link"
            @click.stop.prevent
          >
            <img
              width="1160"
              height="685"
              class="wp-post-image"
              data-fallback="/img/no-image.jpg"
              :src="postImgSrc"
              :alt="$h.getAlt(postTitle)"
              :title="postTitle"
              itemprop="image"
              onerror="this.onerror=null;this.src=this.getAttribute('data-fallback')"
            />
          </a>
        </figure>
        <div
          class="seasidetms_post_content entry-content"
          itemprop="articleBody"
        >
          <p v-html="postDescriptions" />
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Preloader from '@/components/Preloader'

export default {
  name: 'BlogArticle',
  components: { Preloader },
  props: {
    slug: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  metaInfo() {
    return {
      title: this.$t('meta.blog.titleTmpl', {
        h1: this.postTitle,
      }),
      link: [
        {
          rel: 'preload',
          as: 'image',
          href: this.postImgSrc,
        },
      ],
      meta: [
        {
          name: 'description',
          content: this.$t('meta.blog.descriptionTmpl', {
            h1: this.postTitle,
          }),
        },
        {
          property: 'og:locale',
          content: this.$store.state.lang ? 'ru_UA' : 'uk_UA',
        },
        {
          property: 'og:description',
          content: this.$t('meta.blog.descriptionTmpl', {
            h1: this.postTitle,
          }),
        },
        {
          property: 'og:title',
          content: this.$t('meta.blog.titleTmpl', {
            h1: this.postTitle,
          }),
        },
        {
          property: 'og:url',
          content: encodeURIComponent(document.location.href),
        },
        {
          property: 'og:image',
          content: `${document.location.origin}${this.postImgSrc}`,
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['posts']),
    post() {
      console.log('*posts', this.posts)
      const post = this.posts.find((p) => p.slug === this.slug)
      console.log('*post', post)
      return post
    },
    postTitle() {
      const post = this.post
      if (!post) return ''
      return post[`name_${this.$i18n.locale}`]
        ? post[`name_${this.$i18n.locale}`]
        : post.name || ''
    },
    postDescriptions() {
      const post = this.post
      if (!post) return ''
      const description = post[`description_${this.$i18n.locale}`]
        ? post[`description_${this.$i18n.locale}`]
        : post[`short_description_${this.$i18n.locale}`]
        ? post[`short_description_${this.$i18n.locale}`]
        : ''

      return description.replace(
        '<img',
        '<img data-fallback="/img/no-image.jpg" onerror="this.onerror=null;this.src=this.getAttribute(\'data-fallback\')"'
      )
    },
    postDate() {
      const post = this.post
      if (!post) return 'January 10, 2017'
      return this.$h.formatDate(post.created)
    },
    postImgSrc() {
      const post = this.post
      if (!post) return 'data:,'
      return `/img${post.photo}`
    },
  },

  beforeMount() {
    this.$store.dispatch('setHeadline', this.$t('mainMenu.blog'))
    this.$store.dispatch('setBreadcrumbs', [{ name: this.$t('mainMenu.blog') }])

    if (!(Array.isArray(this.posts) && this.posts.length)) {
      this.$store
        .dispatch('fetchBlog')
        .then(() => {
          if (!this.post) {
            this.$store
              .dispatch('fetchPost', this.slug)
              .then(() => {
                this.loading = false
              })
              .catch((err) => {
                console.log('*err', err)
              })
          } else {
            this.loading = false
          }
        })
        .catch((err) => {
          console.log('*err', err)
        })
    } else {
      this.loading = false
    }
  },
}
</script>

<style></style>
